import React, { useState } from "react";
import { Link } from "react-router-dom";
import Logo from "../../assets/Opensource-01.png";
import axios from "axios";
import { toast } from "react-toastify";
import { Helmet } from "react-helmet";
import "./addNewManager.css";

const isValidRegionM = (regionM) => regionM !== "المنطقه";
const isValidRole = (role) => role !== "الدور";
const isValidUserName = (name) => name.trim() !== "";

const isValidMobile = (mobile) => {
  const ksaMobileRegex = /^(009665|9665|05)[0-9]{8}$/;
  return ksaMobileRegex.test(mobile);
};

// const isValidMobile = (mobile) => /^\d+$/.test(mobile) && mobile.length >= 6;

const isValidPassword = (password) =>
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/.test(
    password
  );

const AddNewManager = () => {
  const [username, setUsername] = useState("");
  const [mobile, setMobile] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("الدور");
  const [regionM, setRegionM] = useState("المنطقه");
  const [usernameError, setUsernameError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [mobileError, setMobileError] = useState("");
  const [regionMError, setRegionMError] = useState("");
  const [roleError, setRoleError] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const roleToRegionMap = {
    Admin: [1, 2],
    ManagerRiad: [1],
    ManagerQassim: [2],
  };

  const submit = async (event) => {
    event.preventDefault();

    setUsernameError("");
    setPasswordError("");
    setMobileError("");
    setRegionMError("");
    setRoleError("");
    setError("");

    const usernameIsValid = isValidUserName(username);
    const passwordIsValid = isValidPassword(password);
    const mobileIsValid = isValidMobile(mobile);
    const roleIsValid = isValidRole(role);
    const regionMIsValid = isValidRegionM(regionM);

    if (!usernameIsValid) setUsernameError("برجاء إدخال الإسم");
    if (!passwordIsValid)
      setPasswordError(
        "يجب أن تحتوي كلمة المرور على 8 أحرف على الأقل، حرف كبير، حرف صغير، رقم، وحرف خاص (@$!%*?&)"
      );
    if (!mobileIsValid)
      setMobileError("رقم الهاتف غير صحيح. الرجاء إدخال رقم صحيح");
    if (!regionMIsValid) setRegionMError("برجاء إختيار المنطقه");
    if (!roleIsValid) setRoleError("برجاء إختيار الدور");

    if (
      !usernameIsValid ||
      !passwordIsValid ||
      !mobileIsValid ||
      !roleIsValid ||
      !regionMIsValid
    ) {
      return;
    }

    setIsSubmitting(true);
    try {
      const response = await axios.post(
        "https://api.generalhome.sa/api/Authenticate/AddNewManager",
        {
          Role: role,
          Username: username,
          Password: password,
          PhoneNumber: mobile,
          MaintenanceAreaId: roleToRegionMap[role],
          FullName: username,
          Email: `${username}@gmail.com`,
        }
      );
      if (response.data.success) {
        toast.success("تم إنشاء الحساب", {
          position: "top-right",
          autoClose: 2000,
        });
        setUsername("");
        setMobile("");
        setPassword("");
        setRole("الدور");
        setRegionM("المنطقه");
      } else {
        setError(response.data.Message || "حدث خطأ أثناء إنشاء الحساب");
      }
    } catch (error) {
      console.error(error);
      setError("حدث خطأ أثناء إنشاء الحساب. يرجى المحاولة مرة أخرى.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <section className="register">
        <Helmet>
          <meta charSet="utf-8" />
          <title>إنشاء حساب</title>
          <link rel="canonical" href="https://generalhome.sa/register" />
        </Helmet>
        <div className="register-container">
          <div className="logo">
            <a href="/">
              <img src={Logo} alt="Logo" />
            </a>
          </div>
          <form onSubmit={submit}>
            <div className="input">
              <input
                autoFocus
                type="text"
                placeholder="إسم المدير"
                value={username}
                onChange={(e) => {
                  setUsername(e.target.value);
                  setUsernameError("");
                }}
              />
              {usernameError && <p className="text-danger">{usernameError}</p>}
            </div>
            <div className="input">
              <input
                type="text"
                placeholder="رقم الجوال (مثال: 05XXXXXXXX)"
                value={mobile}
                onChange={(e) => {
                  setMobile(e.target.value);
                  setMobileError("");
                }}
              />
              {mobileError && <p className="text-danger">{mobileError}</p>}
            </div>
            <div className="input">
              <input
                type="password"
                placeholder="كلمة المرور"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  setPasswordError(
                    e.target.value.length > 0 &&
                      !isValidPassword(e.target.value)
                      ? "يجب أن تحتوي كلمة المرور على 8 أحرف على الأقل، حرف كبير، حرف صغير، رقم، وحرف خاص"
                      : ""
                  );
                }}
              />
              {passwordError && <p className="text-danger">{passwordError}</p>}
              {password.length > 0 && (
                <div className="password-requirements">
                  <small>متطلبات كلمة المرور:</small>
                  <ul>
                    <li className={password.length >= 8 ? "valid" : "invalid"}>
                      {password.length >= 8 ? "✓ " : "✗ "}8 أحرف على الأقل
                    </li>
                    <li
                      className={/[A-Z]/.test(password) ? "valid" : "invalid"}
                    >
                      {/[A-Z]/.test(password) ? "✓ " : "✗ "}حرف كبير (A-Z)
                    </li>
                    <li
                      className={/[a-z]/.test(password) ? "valid" : "invalid"}
                    >
                      {/[a-z]/.test(password) ? "✓ " : "✗ "}حرف صغير (a-z)
                    </li>
                    <li className={/\d/.test(password) ? "valid" : "invalid"}>
                      {/\d/.test(password) ? "✓ " : "✗ "}رقم (0-9)
                    </li>
                    <li
                      className={
                        /[@$!%*?&]/.test(password) ? "valid" : "invalid"
                      }
                    >
                      {/[@$!%*?&]/.test(password) ? "✓ " : "✗ "}حرف خاص
                      (@$!%*?&)
                    </li>
                  </ul>
                </div>
              )}
            </div>
            <div className="input">
              <select
                value={role}
                onChange={(e) => {
                  const selectedRole = e.target.value;
                  setRole(selectedRole);
                  setRoleError("");
                  if (selectedRole === "Admin") {
                    setRegionM("0"); // Just for display, not used in payload
                  } else {
                    setRegionM(selectedRole === "ManagerRiad" ? "1" : "2");
                  }
                }}
              >
                <option value="الدور">الدور</option>
                <option value="Admin">مدير عام</option>
                <option value="ManagerRiad">مدير منطه الرياض</option>
                <option value="ManagerQassim">مدير منطقه القصيم</option>
              </select>
              {roleError && <p className="text-danger">{roleError}</p>}
            </div>
            <div className="input">
              <select value={regionM} disabled>
                <option value="المنطقه">المنطقه</option>
                <option value="0">مدير عام (جميع المناطق)</option>
                <option value="1">مدير منطه الرياض</option>
                <option value="2">مدير منطقه القصيم</option>
              </select>
              {regionMError && <p className="text-danger">{regionMError}</p>}
            </div>
            <div>
              <button className="reg-btn" type="submit" disabled={isSubmitting}>
                {isSubmitting ? "جاري المعالجة..." : "إنشاء حساب"}
              </button>
            </div>
            {error && <p className="text-danger text-center mt-2">{error}</p>}
          </form>
          <Link to="/login">
            <button className="login">Login</button>
          </Link>
        </div>
      </section>
    </>
  );
};

export default AddNewManager;
